import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../text-input/TextInput';
import SelectBox from '../select-box/SelectBox';
import './VideoInput.css';

export default class VideoInput extends Component {
  constructor(props) {
    super(props);
    this.previewDivId = this.props.id.replace(/\s/g, '') + "__video-preview";
    this.state = {
      existingContentObject: (this.props.existingContentObject) || {}
    };
  }

  componentWillReceiveProps(newProps) {
    // For case where user is going from edit-mode to read-only-mode (like onCancel)
    if (
      newProps.existingContentObject !== this.props.existingContentObject &&
      this.props.isEditable &&
      !newProps.isEditable
    ) {
      this.setState({ existingContentObject: newProps.existingContentObject });
    }
  }

  // Grabs the values from the inputs and updates the state with the new values
  getValue = (selectedValues, inputId) => {
    if (this.props.isEditable) {
      let newVideoObject = {};
      newVideoObject["videoId"] = this[`${this.props.id}__video-id`].getValue();
      newVideoObject["caption"] = this[`${this.props.id}__video-caption`].getValue();
      newVideoObject["type"] = this[`${this.props.id}__video-type`].getValue();

      this.setState({ existingContentObject: newVideoObject });

      return newVideoObject;
    }

    return this.state.existingContentObject;
  }

  adjustPreviewHeight = () => {
    let type = (this.props && this.props.id && this[`${this.props.id}__video-type`] && this[`${this.props.id}__video-type`].getValue()) ?
               this[`${this.props.id}__video-type`].getValue() :
               null;
    type = type || (this.state && this.state.existingContentObject ? this.state.existingContentObject.type : null);
    let theDiv = document.getElementById(this.previewDivId);
    if (type && theDiv) {
      let theNewHeight = type === 'video' ?
                          `${theDiv.offsetWidth * 9 / 16}px` :
                          `${theDiv.offsetWidth * 9 / 16 + 205}px`;

      theDiv.setAttribute("style",`height:${theNewHeight};overflow:hidden;`);
      theDiv.style.height = theNewHeight;
    }
  }


  loadVideo() {
    if (this.state &&
        this.state.existingContentObject &&
        this.state.existingContentObject.videoId &&
        this.state.existingContentObject.type !== 'none') {


      let embedData = this.state.existingContentObject.type === 'video' ?
      {
        "targetId": this.previewDivId,
        "wid": "_2207941",
        "uiconf_id": 37292221,
        "flashvars": {
          "streamerType": "auto",
          "IframeCustomPluginCss1" : "/assets/styles/vendor/kaltura-styles.css"
        },
        "entry_id": this.state.existingContentObject.videoId
      } :
      {
        "targetId": this.previewDivId,
        "wid": "_2207941",
        "uiconf_id": 37292221,
        "flashvars": {
          "streamerType": "auto",
          "IframeCustomPluginCss1" : '/assets/styles/vendor/kaltura-playlist-styles.css',
          "playlistAPI": {
            "containerPosition" : "bottom",
            "layout" : "vertical",
            "MinClips": 2,
            "kpl0Id": this.state.existingContentObject.videoId
          }
        }
      };

      if (window.kWidget) {
        window.kWidget.embed(embedData);
      }
      this.adjustPreviewHeight();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.loadVideo();
    switch(this.input) {
      case "videoId":
        this[`${this.props.id}__video-id`].focusAtSetCaret(this.caretPosition);
        break;
      case "caption":
        this[`${this.props.id}__video-caption`].focusAtSetCaret(this.caretPosition);
        break;
      case "type":
      default:
        this[`${this.props.id}__video-type`].focus();
    }
  }

  componentDidMount() {
    this.loadVideo();
    window.addEventListener('resize', this.adjustPreviewHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustPreviewHeight);
  }

  render () {
    let typeOptions = [
      { name: 'none', value: 'none' },
      { name: 'video', value: 'video' },
      { name: 'playlist', value: 'playlist' }
    ];

    const label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    // Shows inputs when in edit mode, and read only versions of inputs if showInputsInReadOnly is true
    let inputDisplay = (this.props.isEditable || this.props.showInputsInReadOnly) ?
      <span>
        <TextInput
          id={`${this.props.id}__video-id`}
          label="Video ID"
          className="field__large"
          disabled={this.props.disabled}
          existingContent={this.state.existingContentObject["videoId"]}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onChange={() => {
            this.caretPosition = this[`${this.props.id}__video-id`].selectionStart();
            this.input = "videoId";
            this.getValue();
          }}
          ref={instance => { this[`${this.props.id}__video-id`] = instance; }}
        />
        <TextInput
          id={`${this.props.id}__video-caption`}
          label="Video Caption"
          className="field__large"
          disabled={this.props.disabled}
          existingContent={this.state.existingContentObject["caption"]}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onChange={() => {
            this.caretPosition = this[`${this.props.id}__video-caption`].selectionStart();
            this.input = "caption";
            this.getValue();
          }}
          ref={instance => { this[`${this.props.id}__video-caption`] = instance; }}
        />
        <SelectBox
          id={`${this.props.id}__video-type`}
          existingContent={ this.state.existingContentObject["type"] }
          disabled={this.props.disabled}
          label="Video Type"
          onChange={() => {
            this.input = "type";
            this.getValue();
          }}
          options={ typeOptions }
          ref={instance => { this[`${this.props.id}__video-type`] = instance; }}
          isEditable={(!this.props.isEditable) ? false : undefined}
          verticalSpacing={this.props.verticalSpacing}
        />
      </span> :
      null;

    let caption = ( this.state.existingContentObject.type === 'video' ||
                    this.state.existingContentObject.type === 'playlist' ) &&
                  this.state.existingContentObject.videoId &&
                  this.state.existingContentObject.caption ?
                  <div className="video-input__caption">{this.state.existingContentObject["caption"]}</div> :
                  null;

    let preview = ( this.state.existingContentObject.type === 'video' ||
                    this.state.existingContentObject.type === 'playlist' ) &&
                  this.state.existingContentObject.videoId ?
                  <div id={this.previewDivId} className="video-input__preview" /> :
                  null;

    return (
      <div key={Math.random()} className="video-input field">
        {label}
        {preview}
        {caption}
        {inputDisplay}
      </div>
    );
  }
}

VideoInput.defaultProps = {
  isEditable: true,
  showInputsInReadOnly: false
};

VideoInput.propTypes = {
  disabled: PropTypes.bool,
  existingContentObject: PropTypes.shape({
    videoId: PropTypes.string,
    caption: PropTypes.string,
    type: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  showInputsInReadOnly: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/shared/components/presentation/video-input/VideoInput.js